import { cleanCompanyName } from "@/shared/lib/company-name";

/** A conservative comparison key; callers must still treat name-only hits as review items. */
export function normalizedCompanyName(name: string): string {
  const cleaned = cleanCompanyName(name);
  const normalized = cleaned
    .toLocaleLowerCase("da-DK")
    .replace(/&/g, " og ")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (normalized) return normalized;

  return name
    .toLocaleLowerCase("da-DK")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

export function companyInitials(name: string): string {
  return name
    .replace(/[.-]/g, " ")
    .split(" ")
    .filter((w) => w.length > 0)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}
